import React, { Component } from 'react';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import TemplateGridMenu from '@src/framework/frame/components/tool-bar/menu/template-grid-menu';
import ToolbarManager, { SelectElementTypes } from '@src/framework/editor/src/js/constants/toolbar-data';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { CLICK_FROM } from '@src/framework/workbench/ui/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { NoteSelection } from '@src/framework/frame/components/tool-bar/node-selection';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { RECOMMEND_TAB_IDS } from '@com/tool-bar/toolbar-grid-menu.interface';

const DropContent = props => (
    <TemplateGridMenu {...props} ></TemplateGridMenu>
);

interface IAddTemplatePanelProps {
    id?: string;
    onDropContentClick?: () => void;
    hideDropDownCb?: () => void;
    clickFrom?: CLICK_FROM;
    activeTabId?: RECOMMEND_TAB_IDS;
    onTabChange?: (tabId: RECOMMEND_TAB_IDS) => void;
}

export class AddTemplatePanel extends Component<IAddTemplatePanelProps> {
    private isFrom?: CLICK_FROM;

    /**
     * PC端模版下拉框
     */
    public render() {
        this.isFrom = this.props.clickFrom;
        const defaultTemplates = ToolbarManager.getGroupListByType(SelectElementTypes.TEMPLATE);
        const disabled = this.getUiDataService().presentation.operation.loading === true
            || this.getUserPriviledgeService().pptEditorState !== PPTEditorStateType.EDITABLE;
        const needShowRecommendLayouts = appConfigInstance
            .getConfig(ToolbarFileMenuConfig.recommendLayout as any) ?? true;

        const dropdownProps = {
            ...defaultTemplates.dropdown,
            disabled,
            needShowRecommendLayouts,
        };

        const masters = this.getUiDataService().presentation.masterList;
        if (masters.length > 0 && masters[0].layoutList.length > 0) {
            dropdownProps.masterList = masters;
        }

        return (
            <DropContent
                {...dropdownProps}
                id={this.props.id}
                onGridClick={this.props.onDropContentClick}
                onMenuClick={this.handleMenuClick}
                handleClickCB={this.props.hideDropDownCb}
                needShowRecommendLayouts={needShowRecommendLayouts}
                activeTabId={this.props.activeTabId}
                onTabChange={this.props.onTabChange}
            />
        );
    }

    private handleMenuClick = (index) => {
        const arr = index.split('.');
        const masterIndex = arr[0];
        const layoutIndex = arr[1];
        console.log(`click ${index} -> ${masterIndex}.${layoutIndex}`);

        NoteSelection.clearNoteSelection();
        if (this.getSelectionService()) {
            this.getSelectionService().lastMouseDownRegion = RegionType.SLIDELIST; // 添加幻灯片，把焦点移动到列表
        }

        const { presentation } = this.getUiDataService();
        const layout = presentation.masterList[masterIndex].layoutList[layoutIndex];
        presentation.addSlide([layout]);
        if (this.isFrom === CLICK_FROM.LEFTBAR) {
            // 上报 幻灯片列表-选择模板添加页面成功
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.PC_EDIT_LIST,
                action: TDWActionType.ADD_TEM_SUC,
            });
            this.props.hideDropDownCb?.();
        }
    };

    private getUiDataService() {
        return this.getAppService().getUiDataService();
    }

    private getSelectionService() {
        return this.getAppService()?.viewableServiceLayer?.selectionService;
    }

    private getAppService() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }

    private getUserPriviledgeService() {
        return this.getAppService().viewableServiceLayer.userPriviledgeService;
    }
}
